import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Icon from 'components/common/Icon/Icon'
import Mixin from 'components/common/Mixin'
import withQuantity from 'components/common/hoc/withQuantity'
import withReduxFormQuantity from 'components/common/hoc/withReduxFormQuantity'

const QuantityComponent = ({
  value,
  increaseHandler,
  decreaseHandler,
  onChange,
  small,
  extraSmall,
  id,
  scalable,
  disabled,
  ...props
}) =>
  <Wrapper data-at-quantityselector className={ props.className }>
    <Button
      data-at-quantityselector-decrease
      aria-label="- or decrease quantity"
      small={ small }
      extraSmall={ extraSmall }
      scalable={ scalable }
      disabled={ disabled }
      onClick={ decreaseHandler }>
      <Icon
        alt=""
        asset={ 'arrow-left-bright-red' }
        width={ extraSmall ? 7 : 10 } />
    </Button>
    <Input
      data-at-quantity-input
      id={ id }
      aria-label="item quantity"
      aria-live="polite"
      readOnly
      small={ small }
      extraSmall={ extraSmall }
      scalable={ scalable }
      disabled={ disabled }
      value={ value }
      onChange={ ({ target: { value }}) => onChange({ value }) } />
    <Button
      data-at-quantityselector-increase
      aria-label="+ or increase quantity"
      small={ small }
      extraSmall={ extraSmall }
      scalable={ scalable }
      disabled={ disabled }
      onClick={ increaseHandler }>
      <Icon
        alt=""
        asset={ 'arrow-right-bright-red' }
        width={ extraSmall ? 7 : 10 } />
    </Button>
  </Wrapper>

QuantityComponent.propTypes = {
  className: PropTypes.string,
  decreaseHandler: PropTypes.func,
  disabled: PropTypes.bool,
  extraSmall: PropTypes.bool,
  id: PropTypes.string,
  increaseHandler: PropTypes.func,
  onChange: PropTypes.func,
  scalable: PropTypes.bool,
  small: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ])
}

export default withQuantity(QuantityComponent)

export const QuantityReduxForm = withReduxFormQuantity(QuantityComponent)
export const QuantityComponentRaw = QuantityComponent


const Wrapper = styled.div`
  display: flex;
  width: 170px;
  ${Media.mobile`
    width: 140px;
  `}
  ${Media.mobileNarrow`
    width: 120px;
  `}
`

const Input = styled.input`
  background-color: transparent;
  color: ${Theme.colors.black_new};
  width: 90px;
  height: 40px;
  max-width: 90px;
  max-height: 40px;
  border: 1px solid ${Theme.colors.grey};
  border-radius: 0;
  border-left: none;
  border-right: none;
  text-align: center;
  ${Mixin.font.GothamBold(14)}
  ${props => props.small && css`
    width: 30px;
    height: 30px;
  `}
  ${props => props.extraSmall && css`
    width: 20px;
    height: 20px;
    font-size: 12px;
  `}
  ${props => props.scalable && css`
    flex-grow: 1;
    width: 33%;
    height: 33vw;
  `}
`

const Button = styled.button`
  width: 40px;
  height: 40px;
  max-width: 40px;
  max-height: 40px;
  text-align: center;
  background: ${Theme.colors.white};
  border: 1px solid ${Theme.colors.grey};
  border-radius: 0;
  padding: 1px 6px;
  ${props => props.small && css`
    width: 30px;
    height: 30px;
  `}
  ${props => props.extraSmall && css`
    width: 20px;
    height: 20px;
  `}

  ${props => props.scalable && css`
    width: 33%;
    height: 33vw;
  `}
`
